import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ModuleSettingsCampus from '@routes/Home/routes/AdminPortal/routes/ModuleSettings/routes/ModuleSettingsCampus';

const ModuleSettingsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ModuleSettings' */ './components/ModuleSettings'
		)
);

export default (store) => {
	return {
		path: 'module-settings',
		element: <AsyncLoading component={<ModuleSettingsLazy />} />,
		children: [ModuleSettingsCampus(store)],
	};
};
